import type { ChangelogEntry } from "../types";

/** VIB-2925: frilanserbanken (mørk bak flagget feature_freelancer_bank og menynøkkelen «frilansere»). */
export const FRILANSERBANKEN_2026_10: ChangelogEntry = {
  id: "2026-10-24-frilanserbanken",
  date: "2026-10-24",
  title: "Frilanserbanken flytter fra Monday til Revehiet",
  summary:
    "Ny side «Frilansere» med fagfelt, vurderinger, veiledende priser, kontaktinfo, lenker og en logg med kommentarer og filer. Rulles ut med funksjonsbryteren «Frilanserbanken».",
  sections: [
    {
      heading: "Frilansere",
      items: [
        {
          title: "Liste gruppert på fagfelt",
          kind: "nytt",
          featureFlag: "feature_freelancer_bank",
          body: "Søk, filtrer på fagfelt, person eller firma, vurdering og testet, og sorter på navn, vurdering, dagspris og sted.",
        },
        {
          title: "Profil med vurderinger, kommentarer og filer",
          kind: "nytt",
          featureFlag: "feature_freelancer_bank",
          body: "Vurder 1 til 5 stjerner, knytt vurderingen til et prosjekt, skriv kommentarer med @-nevning og legg ved prislister eller CV-er. Filene ligger privat og åpnes med tidsbegrensede lenker.",
        },
        {
          title: "Personvern",
          kind: "nytt",
          featureFlag: "feature_freelancer_bank",
          body: "Administrator kan eksportere alt om én frilanser og slette permanent. Loggen lagrer aldri kontaktinfo eller kommentartekst.",
        },
      ],
    },
  ],
};
